<template>
  <div class="become-provider">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">如何成为服务商？</div>
      </div>
      <div class="module-body">
        <div class="module-body-left">
          <div class="data-item" v-for="item in dataList" :key="item.id">
            <div class="data-item-header" @click="activeId = item.id">
              <img class="data-item-icon" :src="require(`@/assets/img/service-provider/BecomeProvider/icon_${item.id}.png`)">
              <div class="data-item-title" :class="{ active: item.id == activeId }">{{ item.name }}</div>
            </div>
            <div class="data-item-remark">{{ item.remark }}</div>
            <div class="data-item-btn" @click="handleGo(item.id, $event)">立即前往<i class="el-icon-arrow-right"></i></div>
          </div>
        </div>
        <div class="module-body-right" :style="{ backgroundImage: `url(${require(`@/assets/img/service-provider/BecomeProvider/img_${activeId}.png`)})` }"></div>
      </div>
    </div>
    <!-- 联系我们 -->
    <ConnectUsPopover ref="ConnectUsPopover" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data () {
    return {
      dataList: [
        { id: 'cwyqy', name: '成为云企业', remark: '前往易隆创-合作页面免费注册云企业' },
        { id: 'sqrzylc', name: '申请入驻易隆创·服务生态', remark: '成为云企业后，申请创建易隆创服务团队' },
        { id: 'tjxgzzzm', name: '提交相关资质证明', remark: '上传企业资质（如营业执照）、团队能力材料（如案例/证书）' },
        { id: 'zscwylcfws', name: '正式成为易隆创服务商，开启接单服务', remark: '通过审核后，正式入驻易隆创·服务生态，同步开启平台接单业务' },
      ],
      activeId: ''
    }
  },
  created() {
    this.activeId = this.dataList[0].id;
  },
  methods: {
    ...mapActions(['setCloudRegisterPopup', 'setWorkOrderPopup']),
    handleGo(id, e) {
      this.activeId = id;
      switch (id) {
        case 'cwyqy':
          this.setCloudRegisterPopup(true);
          break;
        case 'sqrzylc':
        case 'tjxgzzzm':
          this.$refs['ConnectUsPopover'].open(e);
          break;
        case 'zscwylcfws':
          this.setWorkOrderPopup(true);
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.become-provider {
  padding: 64px 0;

  .content-center {
    .module-title {
      text-align: left;
    }
    .module-body {
      margin-top: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .module-body-left {
        .data-item {
          padding: 0 0 65px 58px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          position: relative;
          &::before {
            content: '';
            width: 26px;
            height: 26px;
            background-image: url('@/assets/img/service-provider/BecomeProvider/icon_dot.png');
            background-size: 100% 100%;
            position: absolute;
            left: 0;
            top: 0;
          }
          &::after {
            content: '';
            width: 1px;
            height: calc(100% - 26px);
            background-image: linear-gradient(to bottom, @primary-color 0%, @primary-color 50%, transparent 50%, transparent 50%);
            background-size: 100% 10px;
            position: absolute;
            top: 26px;
            left: 13px;
            transform: translateX(-50%);
          }
          &:last-child {
            padding-bottom: 0;
            &::after {
              display: none;
            }
          }
          .data-item-header {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .data-item-icon {
              width: 22px;
              height: 22px;
              margin-right: 8px;
            }
            .data-item-title {
              line-height: 26px;
              font-family: @font-medium;
              font-size: 18px;
              cursor: pointer;
              &:hover {
                color: @primary-color;
              }
              &.active {
                color: @primary-color;
                position: relative;
                &::after {
                  content: '';
                  width: 16px;
                  height: 16px;
                  background-image: url('@/assets/img/service-provider/BecomeProvider/icon_check.png');
                  background-size: 100% 100%;
                  position: absolute;
                  right: -10px;
                  top: 50%;
                  transform: translate(100%, -50%);
                }
              }
            }
          }
          .data-item-remark {
            margin-top: 8px;
            font-size: 14px;
          }
          .data-item-btn {
            display: inline-block;
            margin-top: 10px;
            font-size: 14px;
            color: @primary-color;
            cursor: pointer;
            &:hover {
              position: relative;
              &::after {
                content: '';
                width: calc(100% - 5px);
                height: 1px;
                background-color: @primary-color;
                position: absolute;
                bottom: -2px;
                left: 0;
              }
            }
            .el-icon-arrow-right {
              margin-left: 4px;
              background-position: center;
            }
          }
        }
      }

      .module-body-right {
        width: 670px;
        height: 500px;
        background-color: #fff;
      }
    }
  }
}
</style>
